<template>
	<admin-base-layout>
		<template slot="admin-page-header">
			<div class="flex-wrap-spacing">
				<h3 class="page-header">Quotas</h3>
			</div>
		</template>

		<template slot="admin-page-content">
			<loader v-if="!quotas"></loader>

			<div class="row" v-if="quotas && quotas.length > 0">
				<div class="col-xs-12 pad0">
					<div class="table-responsive">
						<table class="table table-hover tests_quotas_table">
							<thead>
								<tr>
									<th>Type</th>
									<th>Used</th>
									<th>Reset</th>
									<th></th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="quota in quotas" v-bind:key="quota.name">
									<td class="tests_quota_name">{{ quota.name }}</td>
									<td class="tests_quota_value">{{ quota.value }} / {{ quota.max }}</td>
									<td class="tests_quota_ttl">
										<span v-if="quota.ttl">{{ [quota.ttl, 'seconds'] | duration('humanize', true) }}</span>
										<span v-else>-</span>
									</td>
									<td class="quota_gauge_col">
										<div class='gauge'>
											<div class='gauge-used' v-bind:style="{ width:quota.value/quota.max*100.+ '%' }"></div>
										</div>
										{{parseInt(quota.value/quota.max*100)}}%
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</template>
	</admin-base-layout>
</template>

<script>
const logger = require("@/utils/logger");
const namespaceService = require("@/utils/namespace-api");
import router from "@/router";
const utils = require("@/utils/utils");

export default {
  data() {
    return {
      quotas: null
    };
  },
  methods: {
    getQuotas() {
      namespaceService
        .getQuotas()
        .then(quotas => {
          this.quotas = quotas;
        })
        .catch(utils.axiosErrorHandler);
    }
  },
  mounted() {
    this.getQuotas();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.quota_gauge_col {
  width: 1%;
  white-space: nowrap;
}
.gauge {
  display: inline-block;
  height: 5px;
  width: 150px;
  margin-right: 5px;
  border-bottom: 1px solid #ccc;
}
.gauge-used {
  height: 3px;
  background: rgb(41, 118, 219);
}
.loader {
  margin-top: 10px;
  text-align: center;
}

.flex-wrap-spacing {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Quotas.vue